import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-floating',
  templateUrl: './contact-floating.component.html',
  styleUrls: ['./contact-floating.component.scss']
})
export class ContactFloatingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
